import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { AppBadges } from "@/components/AppBadges";
import { FEATURES } from "@/data/site";
import { Check } from "lucide-react";

export default function FeaturesPage() {
  return (
    <>
      <Seo
        title="Features"
        description="Explore everything Kinect Nova AI offers — medication management, Emergency SOS, AI Family Coordinator, medical passport, teleconsultation and more."
        path="/features"
      />
      <PageHeader
        eyebrow="Features"
        title="Everything your family needs, in one app"
        subtitle="Eleven thoughtfully designed features that work together to keep your loved ones healthy, connected and safe."
      />

      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24">
        <div className="space-y-20 lg:space-y-28">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            const reversed = i % 2 === 1;
            return (
              <div
                key={f.slug}
                id={f.slug}
                className="grid scroll-mt-24 items-center gap-10 lg:grid-cols-2 lg:gap-16"
              >
                <Reveal className={reversed ? "lg:order-2" : ""}>
                  <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                    <Icon className="h-7 w-7" strokeWidth={1.75} />
                  </div>
                  <h2 className="mt-6 font-heading text-3xl font-semibold tracking-tight text-foreground sm:text-4xl">
                    {f.title}
                  </h2>
                  <p className="mt-4 text-lg leading-relaxed text-muted-foreground">{f.long}</p>
                  <ul className="mt-6 space-y-2">
                    {[f.short, "Private & encrypted by design", "Built for the whole family"].map((point) => (
                      <li key={point} className="flex items-start gap-3 text-base text-foreground">
                        <Check className="mt-1 h-4 w-4 shrink-0 text-primary" />
                        {point}
                      </li>
                    ))}
                  </ul>
                </Reveal>

                <Reveal delay={0.1} className={reversed ? "lg:order-1" : ""}>
                  <div className="overflow-hidden rounded-3xl border border-border bg-card shadow-sm">
                    <img
                      src={f.image}
                      alt={f.title}
                      loading="lazy"
                      className="aspect-[4/3] w-full object-cover"
                    />
                  </div>
                </Reveal>
              </div>
            );
          })}
        </div>

        <div className="mt-24 rounded-[2rem] border border-border bg-secondary/40 p-10 text-center">
          <h2 className="font-heading text-3xl font-semibold tracking-tight text-foreground">
            Ready to get started?
          </h2>
          <p className="mx-auto mt-3 max-w-lg text-muted-foreground">
            Download Kinect Nova AI free and bring all of these features to your family today.
          </p>
          <div className="mt-7 flex justify-center">
            <AppBadges className="justify-center" />
          </div>
        </div>
      </div>
    </>
  );
}
